import {
    SET_userLoginIn,
    SET_userLoginOut,
    SET_userBindingIn,
    SET_userBindingOut,
    SET_searchInputValue,
    SET_title,
    SET_tabbarIndex,
    SET_userSexMan,
    SET_userSexWomen,
    SET_userSexDefault,
    SET_userAddress,
    UPDATE_loadingStatus,
    SET_avatar,
    SET_name,
    SET_nickName,
    SET_mobile,
    SET_type,
    SET_orgLogo,
    SET_baseurl,
    SET_orgName
} from './mutations-type'



export default {
    [SET_searchInputValue]({ commit }, searchValue) {
        commit(SET_searchInputValue, searchValue)
    },
    [SET_title]({ commit }, title) {
        commit(SET_title, title)
    },
    [SET_tabbarIndex]({ commit }, index) {
        commit(SET_tabbarIndex, index)
    },
    [SET_userSexMan]({ commit }) {
        commit(SET_userSexMan)
    },
    [SET_userSexWomen]({ commit }) {
        commit(SET_userSexWomen)
    },
    [SET_userSexDefault]({ commit }) {
        commit(SET_userSexDefault)
    },
    [SET_userAddress]({ commit }, address) {
        commit(SET_userAddress, address)
    },
    [UPDATE_loadingStatus]({ commit }, payload) {
        commit(UPDATE_loadingStatus, payload)
    },
    [SET_avatar]({ commit }, avatar) {
        commit(SET_avatar, avatar)
    },
    [SET_name]({ commit }, name) {
        commit(SET_name, name)
    },
    [SET_nickName]({ commit }, nickname) {
        commit(SET_nickName, nickname)
    },
    [SET_mobile]({ commit }, mobile) {
        commit(SET_mobile, mobile)
    },
    [SET_userLoginIn]({ commit }) {
        commit(SET_userLoginIn)
    },
    [SET_userLoginOut]({ commit }) {
        commit(SET_userLoginOut)
    },
    [SET_userBindingIn]({ commit }) {
        commit(SET_userBindingIn)
    },
    [SET_userBindingOut]({ commit }) {
        commit(SET_userBindingOut)
    },
    [SET_type]({ commit }, type) {
        commit(SET_type, type)
    },
    [SET_orgLogo]({ commit }, orgLogoUrl) {
        commit(SET_orgLogo, orgLogoUrl)
    },
    [SET_baseurl]({ commit }, baseurl) {
        commit(SET_baseurl, baseurl)
    },
    [SET_orgName]({ commit }, orgName) {
        commit(SET_orgName, orgName)
    }
}


// WEBPACK FOOTER //
// ./src/store/actions.js